import forOwn from 'mout/object/forOwn'
import contains from 'mout/array/contains'

/**
 * Computes data for summary bars for each card on dashboard.
 * @param {object} nodes All nodes in db.collection('knowledgeMapNodes')
 * @param {object} byNodeScoring userAssessment.scoring.byNode scoring object for this subtest.
 * @param {object} subtest from userAssessment.assessmentSubtests
 * @returns {array} {name, raw, possible, } for each direct child node
 */
export default function computeSummaryNodeData(nodes, byNodeScoring, subtest) {
  let output = []

  const subtestNodeTag = subtest.nodeTag

  const subtestNodeChildren = nodes[subtestNodeTag]&& nodes[subtestNodeTag].children

  function getAllChildrenNodes(node, allNodes) {
    let collectedNodes = [node.id,]
    if (node.children) {
      forOwn(node.children, (val, key, o) => {
        if (val) {
          if (!contains(collectedNodes, key)) {
            collectedNodes.push(key)
            if (allNodes[key].children) {
              getAllChildrenNodes(allNodes[key], allNodes).forEach((nodeKey) => {
                if (!contains(collectedNodes, nodeKey)) {
                  collectedNodes.push(nodeKey)
                }
              })
            }
          }
        }
      })
    }
    return collectedNodes
  }

  forOwn(subtestNodeChildren, (check, parentNode) => {
    if (check) {
      let subnodeCollection = getAllChildrenNodes(nodes[parentNode], nodes)
      let raw = 0
      let possible = 0
      subnodeCollection.forEach((subnode) => {
        if (byNodeScoring[subnode]) {
          raw = parseInt(byNodeScoring[subnode].raw) + parseInt(raw)
          possible = parseInt(byNodeScoring[subnode].possible) + parseInt(possible)
        }
      })
      output.push({
        name: nodes[parentNode].name,
        raw,
        possible,
      })
    }
  })
  return output

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/computeSummaryNodeData.js